import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppConstant } from '../../../../../Assests/AppConstant';
import Header from '../../../../Header/Header';
import Navigationbar from '../../../../Navigationbar/Navigationbar';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import WarehouseSearch from '../../../../SuperWarehouse/Components/SearchWarehouse/WarehouseSearch';
import { getSuperAdminSelector } from '../../../../../../redux/reducers/reducerSlices/SuperAdminReducerSlice';
import RequestsReceivedTableSection from './RequestsReceivedTableSection/RequestsReceivedTableSection';
import './RequestsReceivedAdmin.css';

const STATUS_FILTERS = AppConstant.requestsReceived.statusFilters;
const STATUS_VALUES = AppConstant.requestsReceived.statusValues;

const statusTabList = [
    { label: STATUS_FILTERS.open, value: STATUS_VALUES.open },
    { label: STATUS_FILTERS.inProgress, value: STATUS_VALUES.inProgress },
    { label: STATUS_FILTERS.resolved, value: STATUS_VALUES.resolved },
    { label: STATUS_FILTERS.rejected, value: STATUS_VALUES.rejected },
    { label: STATUS_FILTERS.all, value: STATUS_VALUES.all },
];

const RequestsReceivedAdmin = (props) => {

    const dispatch = useDispatch();
    const [selectedSection, setSelectedSection] = useState('Feedback');
    const [selectedStatus, setSelectedStatus] = useState(STATUS_VALUES.open);
    const [searchStr, setSearchStr] = useState('');
    const superAdminSagaObj = useSelector(getSuperAdminSelector);
    const { issuesList, feedbackList, issuesTotalCount, feedbackTotalCount } = superAdminSagaObj;
    const [feedbackApiList, setFeedbackApiList] = useState([]);
    const [issuesApiList, setIssuesApiList] = useState([]);

    const selectSection = (sectionStr) => {
        setSelectedSection(sectionStr)
    }

    const selectStatus = (statusValue) => {
        setSelectedStatus(statusValue);
    }

    // Fetch total counts (all statuses) once on mount
    useEffect(() => {
        getTotalCounts();
    }, [])

    useEffect(() => {
        getFeedbacksAndIssuesList();
    }, [selectedSection, selectedStatus])

    useEffect(() => {
        if (feedbackList && feedbackList.length) {
            setFeedbackApiList(feedbackList)
        } else {
            setFeedbackApiList([])
        }
        // Refresh total counts so header badges stay accurate after updates
        getTotalCounts();
    }, [feedbackList])

    useEffect(() => {
        if (issuesList && issuesList.length) {
            setIssuesApiList(issuesList)
        } else {
            setIssuesApiList([])
        }
        // Refresh total counts so header badges stay accurate after updates
        getTotalCounts();
    }, [issuesList])

    const getTotalCounts = () => {
        dispatch({
            type: sagaActions.GET_ISSUES_TOTAL_COUNT,
            payload: { "Id": null, "name": null, "email": null, "phoneNumber": null, "issue": null, "feedback": null, "fileOne": null, "fileTwo": null, "ownedBy": null, "status": null, "type": "Issue", "crud_type": "S", "AppType": null }
        });
        dispatch({
            type: sagaActions.GET_FEEDBACK_TOTAL_COUNT,
            payload: { "Id": null, "name": null, "email": null, "phoneNumber": null, "issue": null, "feedback": null, "fileOne": null, "fileTwo": null, "ownedBy": null, "status": null, "type": "Feedback", "crud_type": "S", "AppType": null }
        });
    }

    const getFeedbacksAndIssuesList = () => {
        const apiIssuesParams = {
            "Id": null,
            "name": null,
            "email": null,
            "phoneNumber": null,
            "issue": null,
            "feedback": null,
            "fileOne": null,
            "fileTwo": null,
            "ownedBy": null,
            "status": selectedStatus,
            "type": "Issue",
            "crud_type": "S",
            "AppType": null
        }
        dispatch({ type: sagaActions.UPDATE_ISSUES_LIST, payload: apiIssuesParams });

        const apiFeedbackParams = {
            "Id": null,
            "name": null,
            "email": null,
            "phoneNumber": null,
            "issue": null,
            "feedback": null,
            "fileOne": null,
            "fileTwo": null,
            "ownedBy": null,
            "status": selectedStatus,
            "type": "Feedback",
            "crud_type": "S",
            "AppType": null
        }
        dispatch({ type: sagaActions.UPDATE_FEEDBACK_LIST, payload: apiFeedbackParams });
    }

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />

            <div className='mt-2 graphHeading'>{`${AppConstant.requestsReceived.requestsReceivedTitle} (${feedbackTotalCount + issuesTotalCount})`}</div>
            <div className='seperator' />
            <div className='d-flex justify-content-between'>
                <div className='d-flex justify-content-start m-2'>
                    <div
                        className={`buttonSectionControl mx-2 ${selectedSection === 'Feedback' ? 'selectedButton' : 'unselectedButton'}`}
                        onClick={() => selectSection('Feedback')}>{`${AppConstant.requestsReceived.feedbackTitle} (${feedbackTotalCount})`}</div>
                    <div
                        className={`buttonSectionControl mx-2 ${selectedSection === 'Issues' ? 'selectedButton' : 'unselectedButton'}`}
                        onClick={() => selectSection('Issues')}
                    >{`${AppConstant.requestsReceived.issuesTitle} (${issuesTotalCount})`}</div>
                </div>
                <div className='w-25'>
                    <WarehouseSearch
                        placeholder={selectedSection === 'Feedback' ? 'Search Feedback' : 'Search Issues'}
                        inputValue={searchStr}
                        cancelSearch={() => setSearchStr('')}
                        onChangeHandler={(text) => setSearchStr(text)} />
                </div>
            </div>

            <div className='seperator' />

            <div className='d-flex justify-content-start m-2'>
                {statusTabList.map((tab) => (
                    <div
                        key={tab.label}
                        className={`buttonSectionControl mx-2 ${selectedStatus === tab.value ? 'selectedButton' : 'unselectedButton'}`}
                        onClick={() => selectStatus(tab.value)}
                    >
                        {selectedStatus === tab.value
                            ? `${tab.label} (${selectedSection === 'Feedback' ? feedbackApiList.length : issuesApiList.length})`
                            : tab.label}
                    </div>
                ))}
            </div>

            <div className='seperator' />
            <div>
                {
                    <RequestsReceivedTableSection
                        searchStr={searchStr}
                        feedbacksList={feedbackApiList}
                        issuesList={issuesApiList}
                        currentSection={selectedSection}
                        selectedStatus={selectedStatus}
                        {...props} />
                }
            </div>
        </div>
    )
}

export default RequestsReceivedAdmin
